import React from 'react';

const VisaCard = ({ width = 30, height = 22 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-734 -297)" fillRule="nonzero">
        <g id="credit_card" transform="translate(128 261)">
          <g id="cards" transform="translate(568 36)">
            <g id="credit-cards_visa" transform="translate(38)">
              <g id="Layer_1">
                <g id="Group">
                  <rect
                    id="Rectangle-path"
                    fill="#F9F9F9"
                    y="5.294"
                    width="30"
                    height="9.412"
                  />
                  <path
                    d="M1.25,0 L28.75,0 C29.4375,0 30,0.529411765 30,1.17647059 L30,5.29411765 L0,5.29411765 L0,1.17647059 C0,0.529411765 0.5625,0 1.25,0 Z"
                    id="Shape"
                    fill="#09599E"
                  />
                  <path
                    d="M0,14.7058824 L30,14.7058824 L30,18.8235294 C30,19.4705882 29.4375,20 28.75,20 L1.25,20 C0.5625,20 0,19.4705882 0,18.8235294 L0,14.7058824 Z"
                    id="Shape"
                    fill="#E59703"
                  />
                  <path
                    d="M1.25,19.9705882 C0.5625,19.9705882 0,19.4411765 0,18.7941176 L0,1.17647059 C0,0.529411765 0.5625,0 1.25,0 L28.75,0 C29.4375,0 30,0.529411765 30,1.17647059"
                    id="Shape"
                    fill="#FFF"
                    opacity="0.05"
                  />
                  <g transform="translate(5.313 7.353)" id="Shape">
                    <polygon
                      fill="#00589F"
                      points="6.28125 5.11764706 7.1875 0.147058824 8.625 0.147058824 7.71875 5.11764706"
                    />
                    <path
                      d="M12.9375,0.294117647 C12.65625,0.205882353 12.21875,0.0882352941 11.65625,0.0882352941 C10.21875,0.0882352941 9.21875,0.764705882 9.21875,1.73529412 C9.21875,2.44117647 9.9375,2.85294118 10.46875,3.08823529 C11.03125,3.32352941 11.21875,3.5 11.21875,3.70588235 C11.21875,4.02941176 10.78125,4.20588235 10.34375,4.20588235 C9.78125,4.20588235 9.46875,4.11764706 9,3.94117647 L8.8125,3.82352941 L8.625,4.94117647 C8.96875,5.08823529 9.59375,5.20588235 10.21875,5.20588235 C11.71875,5.20588235 12.71875,4.52941176 12.71875,3.5 C12.71875,2.94117647 12.34375,2.5 11.5,2.14705882 C11,1.91176471 10.6875,1.76470588 10.6875,1.52941176 C10.6875,1.32352941 10.9375,1.08823529 11.5,1.08823529 C11.96875,1.08823529 12.3125,1.17647059 12.5625,1.26470588 L12.6875,1.32352941 L12.9375,0.294117647"
                      fill="#00589F"
                    />
                    <path
                      d="M16.625,0.176470588 L15.5,0.176470588 C15.15625,0.176470588 14.90625,0.264705882 14.75,0.588235294 L12.625,5.14705882 L14.125,5.14705882 C14.125,5.14705882 14.375,4.52941176 14.4375,4.41176471 L16.28125,4.41176471 C16.3125,4.58823529 16.46875,5.14705882 16.46875,5.14705882 L17.8125,5.14705882 L16.625,0.176470588 L16.625,0.176470588 Z M14.84375,3.35294118 C14.96875,3.05882353 15.40625,1.97058824 15.40625,1.97058824 C15.40625,1.97058824 15.53125,1.67647059 15.59375,1.5 L15.6875,1.94117647 C15.6875,1.94117647 15.96875,3.11764706 16.03125,3.38235294 L14.84375,3.38235294 L14.84375,3.35294118 Z"
                      fill="#00589F"
                    />
                    <path
                      d="M5.0625,0.176470588 L3.65625,3.55882353 L3.5,2.88235294 C3.25,2.08823529 2.40625,1.23529412 1.5,0.794117647 L2.8125,5.11764706 L4.34375,5.11764706 L6.625,0.147058824 L5.0625,0.147058824"
                      fill="#00589F"
                    />
                    <path
                      d="M2.34375,0.147058824 L0.03125,0.147058824 L0,0.264705882 C1.8125,0.676470588 3,1.67647059 3.5,2.85294118 L3,0.588235294 C2.9375,0.264705882 2.65625,0.176470588 2.34375,0.147058824"
                      fill="#F9A51A"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default VisaCard;



// WEBPACK FOOTER //
// ../shop_main/images/visaCardIcon.js